
import {
  SET_STORES,
} from "../actions/actions"

export default function (state = { stores: [] }, action) {
  switch (action.type) {
    case SET_STORES: {
      return {
        ...state,
        stores: action.payload
      }
    }

    default: return state;
  }
}